"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapSeo = function mapSeo(slice) {
  if (!slice || slice.length < 1) return false;
  return {
    h1: slice[0].primary.h1[0].text,
    h4: slice[0].primary.h4[0].text,
    text: slice[0].primary.text[0].text
  };
};
var _default = mapSeo;
exports["default"] = _default;